import { api } from './../function/api.js';
import { loadStripe } from '@stripe/stripe-js';

export class cCart {
	constructor() {
		$('body').on('click', '.cart .cart__entry--trip .delete', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.remove_cart_trip($(this));
		});
	}
	
	async load() {
		let data = new FormData();
		let response = {};
		console.log("Running Cart Load");
		
		if($('.cart').hasClass('receipt')){
			return false;
		}
		
		response = await api('/api/checkout/cart', data);
		
		if(response.error){
			$('.cart__body').html('<p style="text-align:center">'+response.message.join('<br/>')+'</p>');
		}else{
			this.render_cart(response.data.trips);
			this.render_payment_options(response.data.stripe);
		} 
	}
	
	render_cart(trips){
		let item = '';
		let total = 0;
		let cart_count = 0;
		
		if($('.cart').is('.receipt')){
			console.log('render stopped');
			return false;
		}else{
			console.log('render continue');
		}
		
		$('.cart .cart__body').html('');
		
		for (const [i, trip] of Object.entries(trips)) {
			item = `
				<div class="cart__entry cart__entry--trip">
					<div class="cart__entry_icon">
						<span class="material-symbols-outlined">location_on</span>
					</div>
					<div class="cart__entry_name">
						<a target="_blank" href="/t/${trip.slug}">${trip.name}</a>
					</div>
					<div class="cart__entry_creator">
						<a target="_blank" href="/u/profile/${encodeURIComponent(trip.short_name)}">${trip.short_name}</a>
					</div>
					<div class="cart__entry_price">
						&dollar;${trip.price}
					</div>
					<div class="cart__entry_edit">
						<span data-trip="${trip.trip_id}" class="delete material-symbols-outlined">cancel</span>
					</div>
				</div>
			`;
			
			total += parseFloat(trip.price);
			cart_count += 1;
			$('.cart .cart__body').append(item);
		}
		
		$('.cart__footer strong').html(`Total: &dollar;${total.toFixed(2)} USD`);
		$('.cart_count').html(cart_count);
	}
	
	async render_payment_options(stripe_secret){
		console.log("Running Payment Options");
		let stripe = {};
		
		if (window.location.hostname === 'jaxbend.com') {
			stripe = await loadStripe('pk_live_51TPs5t7WKLALOIjGDsvixGuJCYghrqvZoMCei3j3jE4hUaedCB9E1u7k5A6m0VaNYLCYOv9utGCMJbBjW9pRfzVj00BNghpdXQ');
		}else{
			stripe = await loadStripe('pk_test_51TPs667nPADwn5YcqnMJg4c48rjNsmz9MRvTLahUxhfPfPsCruIKnb4oWpSCDdwFjrXHaTbwJxvCTyakiLgVH9ju00TElE0yQY');
		}
		
		const checkout = stripe.initCheckoutElementsSdk({clientSecret : Promise.resolve(stripe_secret.client_secret)});
		const loadActionsResult = await checkout.loadActions();

		if (loadActionsResult.type === 'success') {
			const session = loadActionsResult.actions.getSession();
			const checkoutContainer = document.getElementById('checkout-container');
			const paymentElement = checkout.createPaymentElement();
			const {actions} = loadActionsResult;
			const button = document.getElementById('pay-button');
			const errors = document.getElementById('confirm-errors');
			let pay_text = "Checkout & Pay";
			
			$('#pay-button').text(`${pay_text} ($${(session.total.total.minorUnitsAmount / 100).toFixed(2)} USD)`);
			paymentElement.mount('#payment-element');
			
			button.addEventListener('click', () => {
				// Clear any validation errors
				errors.textContent = '';

				actions.confirm().then((result) => {
					if (result.type === 'error') {
						errors.textContent = result.error.message;
					}
				});
			});
		}
	}
	
	async remove_cart_trip($target) {
		let data = new FormData();
		let response = {};
		data.append('trip', $target.attr('data-trip'));
		
		response = await api('/api/checkout/remove-trip', data);
		
		if(response.error){
			
		}else{
			this.load();
		} 
	}
	
	added_to_cart($target){
		let count = parseFloat($('.cart_count').text());
		count = count + 1;
		$('.cart_count').text(count);
		$target.html(`<a href="/checkout" class="btn btn--secondary">Checkout</strong>`);
	}
}